import React from 'react'

class DetailVideoBox extends React.Component {
    render() {
        return (
            <div className="col-lg-6 col-md-12 col-sm-12" >
                <div className="inner-column clearfix wow fadeInRight" >
                    <div className="image">
                        <img src="/images/asritlogo.png" alt="" style={{marginTop:'-100px '}}/>
                    </div>
                    {/* <a href="https://www.youtube.com/watch?v=kxPCFljwJws" className="lightbox-image play-box"><span className="flaticon-play-button"><i className="ripple"></i></span></a> */}
                </div>
            </div>
        )
    }
}
export default DetailVideoBox